module.exports = __webpack_public_path__ + "img/157.f13fa1e0.jpg";